// extracted by mini-css-extract-plugin
module.exports = {"buddies":"byBuddiesHR_buddies__XO8xu","logoText":"byBuddiesHR_logoText__d2T1w","white":"byBuddiesHR_white__d3EAN"};